export class RequestAbortedError extends Error {
  constructor() {
    super("Request has been cancelled by AbortController");
    this.name = "RequestAbortedError";
  }
}
